import apiClient from '@/lib/axios'

export const getFeatureFlags = async (
  params: GetFeatureFlagsParams
): Promise<FeatureFlagsResponse> => {
  const response = await apiClient.get('/feature-flags/share', {
    params: params ? params : {},
  })
  return response.data
}
